import React from "react";

const Resorceedit = () => {
  return <div>Resorceedit</div>;
};

export default Resorceedit;
